<template>
  <div class="maps" style="width: 100%; height: 100%; position:relative;">

      <GmapMap :center="{lat: 21.4389, lng: -158.0001}" :zoom="11"> 

          <Traffic-Layer
          ></Traffic-Layer>
          <!-- <Heat-Map :data="{lat: parseFloat(markers[0].lat),lng: parseFloat(markers[0].long)}"></Heat-Map> -->
          <gmap-marker
            :key="index"
            v-for="(items, index) in markers"
            :position="{lat: parseFloat(items.lat), lng: parseFloat(items.long)}"
            @click="center={lat: parseFloat(items.lat), lng: parseFloat(items.long)}; showInfo(items)"
          ></gmap-marker>
      </GmapMap>

      <Pin-Display :admin="admin"></Pin-Display> <!-- Used for the dialog -->

  </div>

</template>

<script>
import {bus} from '@/main.js';
import {database,storage} from '@/fb.js';
import Traffic from '@/assets/map/TrafficLayer.js';
import HeatMap from '@/assets/map/HeatMapLayer.js';
import PinCard from './PinWindow';

// var subInstance = Vue.extend(PinCard); //creates subclass of vue constructor

export default {
  name: 'MapsPage',
  components: {
      'Traffic-Layer': Traffic,
      'Heat-Layer': HeatMap,
      'Pin-Display': PinCard
  },
  props: {
      admin: Boolean
  },
  data () {
      return {
          markers: [],

          curCard: {
              picture: '',
              comments:[],
          }
      }
  },
  created() {
      database.collection('Pins').onSnapshot(data => {
          let temp = [];
          data.forEach(function(doc) {
                temp.push(doc.data());
            });
          this.markers = temp;
          console.log(data);
      });
  },
  methods: {
      showInfo(content) {
          console.log(content.image);
          let tempInfo = content; //holds the content that is 

          storage.ref().child(content.image).getDownloadURL().then(url => { //gets image url of the path stated on the pin object and opens a dialog box

            tempInfo.image = url;
          }).catch(() => {
              bus.$emit('showCard',tempInfo);
          });
      }
  }
}
</script>

<style>
.vue-map-container {
    height: 100%;
}
</style>